var map = {
	"./BIS.svg": 5512,
	"./Execution.svg": 480,
	"./Img.svg": 1795,
	"./Improvement.svg": 8182,
	"./Logo SIM.jpg": 1332,
	"./OTP.svg": 5673,
	"./Planning.svg": 3561,
	"./Rectangle.svg": 209,
	"./Review.svg": 3846,
	"./bg 4.svg": 9371,
	"./bg-1.svg": 8553,
	"./bg-img.png": 8455,
	"./bg.5.svg": 828,
	"./bg.svg": 2703,
	"./bg2.svg": 2671,
	"./cloudhomes.svg": 4263,
	"./connect.svg": 6112,
	"./contact.svg": 5942,
	"./elemen.svg": 5590,
	"./hartech.png": 4223,
	"./icon1.png": 5270,
	"./icon1.svg": 9782,
	"./icon2.svg": 2741,
	"./icon3.svg": 1460,
	"./icon4.svg": 3083,
	"./icon5.svg": 1114,
	"./img-hover1.png": 2453,
	"./img-hover2.png": 4622,
	"./img-hover3.png": 4119,
	"./img-hover4.png": 1976,
	"./img-hover5.png": 3105,
	"./img1.svg": 6424,
	"./logo ABC.png": 6945,
	"./logo bca.png": 3768,
	"./logo coffe crowd.png": 3785,
	"./logo cop buntut.png": 8126,
	"./logo gvs.png": 6987,
	"./logo hana bank.png": 5569,
	"./logo interpan.png": 8158,
	"./logo phisoft.png": 728,
	"./logo rossy.jpeg": 6070,
	"./logo suzuya.png": 7800,
	"./logo tea garden.png": 1172,
	"./logo vgroup.png": 3774,
	"./logo yayasan baitul maal.png": 9643,
	"./logo yumeida.png": 4581,
	"./main.css": 10,
	"./phipos.svg": 1207,
	"./phipos.webp": 3462,
	"./pupuk logistik.webp": 6316,
	"./shilin.png": 3783,
	"./step.svg": 4288,
	"./welcome.svg": 3330,
	"./workflow.svg": 7905
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;